import React from 'react'
import './cardstack.css'

const CardStack = ({cards}) => {
  return (
    <section className="card-stack-wrapper">

      {cards.map((card, index) => (
        <article
          className="stack-card"
          key={card.id}
          style={{
            "--card-index": index,
            "--sticky-top": `${20 + index * 75}px`,
          }}
        >

            <h2 className='card-title'>{card.title}</h2>

          <div className="card-content">

            {/* Left */}
            <div className="card-info">

              

              <p>{card.description}</p>

              <a
                href={card.button.link}
                className="expert-button"
              >
                {card.button.text}
              </a>

            </div>


            {/* Services */}
            <div className="card-services">

              <h3>{card.servicesTitle}</h3>

              <ul>
                {card.services.map((service, serviceIndex) => (
                  <li key={serviceIndex}>
                    {service}
                  </li>
                ))}
              </ul>

            </div>


            {/* Case Study */}
            <a
              href={card.caseStudy.link}
              className="case-card"
            >

              <div className="case-image">

                <img
                  src={card.caseStudy.image}
                  alt={card.caseStudy.title}
                  loading="lazy"
                />

                <span className="case-label">
                  {card.caseStudy.label}
                </span>

              </div>

              <h4>{card.caseStudy.title}</h4>
              <p>{card.caseStudy.description}</p>

              <span className="case-arrow">
                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.7071 8.07136C18.0976 7.68084 18.0976 7.04768 17.7071 6.65715L11.3431 0.29319C10.9526 -0.0973344 10.3195 -0.0973344 9.92893 0.29319C9.53841 0.683714 9.53841 1.31688 9.92893 1.7074L15.5858 7.36426L9.92893 13.0211C9.53841 13.4116 9.53841 14.0448 9.92893 14.4353C10.3195 14.8259 10.9526 14.8259 11.3431 14.4353L17.7071 8.07136ZM0 7.36426V8.36426H17V7.36426V6.36426H0V7.36426Z" fill="white"/>
                </svg>
              </span>

            </a>

          </div>

        </article>
      ))}

    </section>
  )
}

export default CardStack